// src/pages/Index.tsx
import Layout from '@/components/layout/Layout';
import HeroSection from '@/components/ui/HeroSection';
import CategoryCard from '@/components/ui/CategoryCard';

const Index = () => {
  const categories = [
    {
      title: "Pohištvo",
      imageSrc: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&q=80",
      url: "/pohistvo"
    },
    {
      title: "Umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki"
    },
    {
      title: "Drobno pohištvo",
      imageSrc: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo"
    },
    {
      title: "Svetila",
      imageSrc: "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?auto=format&fit=crop&q=80",
      url: "/svetila"
    },
    {
      title: "Ogledala",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala"
    },
    {
      title: "Dodatki",
      imageSrc: "https://images.unsplash.com/photo-1632120399340-dd60f322e57e?auto=format&fit=crop&q=80",
      url: "/dodatki"
    }
  ];

  return (
    <Layout
      title="Lux Decor by Kamen | Luksuzna kopalniška oprema"
      description="Odkrijte brezčasno eleganco in vrhunsko kakovost naših luksuznih kopalniških izdelkov, ki bodo vašo kopalnico spremenili v oazo miru in razkošja."
      keywords="luksuzna kopalnica, kopalniški dodatki, umivalniki, pohištvo, svetila, ogledala"
    >
      <HeroSection
        title="Luksuz v vaši kopalnici"
        subtitle="Premium izbor"
        description="Odkrijte brezčasno eleganco in vrhunsko kakovost naših luksuznih kopalniških izdelkov, ki bodo vašo kopalnico spremenili v oazo miru in razkošja. Naša ponudba vključuje skrbno izbrane detajle, od elegantnih umivalnikov in razkošnih kopalniških dodatkov do vrhunskih materialov, ki združujejo funkcionalnost in estetsko dovršenost."
        ctaText="Zahtevaj ponudbo"
        ctaLink="/kontakt"
        backgroundImage="https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&q=80"
      />

      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold mb-2">Naše Kategorije</h2>
            <p className="text-luxgray max-w-2xl mx-auto">
              Razvajajte se z našo ekskluzivno izbiro premium izdelkov za vašo kopalnico
            </p>
            <div className="h-px w-24 bg-luxgold mx-auto mt-4"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category, index) => (
              <CategoryCard
                key={index}
                title={category.title}
                imageSrc={category.imageSrc}
                url={category.url}
              />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Index;